/**
 * Convert time to a more readable format
 *
 * @param milliSeconds - time in milliseconds
 * @param format - the format you want to output
 * (might have to write new code if you want a different format)
 * @returns string - Time in a readably string
 */
export function convertToReadableTime(milliSeconds: number, format: string) {
    if (format === "u:mm:ss") {
        const seconds = Math.floor(milliSeconds / 1000);
        const h = Math.floor(seconds / 3600);
        const m = Math.floor(seconds % 3600 / 60);
        const s = Math.floor(seconds % 3600 % 60);

        let hDisplay;
        let mDisplay;
        let sDisplay;

        hDisplay = h > 0 ? h + ":" : "0:";
        mDisplay = m > 0 ? m + ":" : "00:";
        sDisplay = s > 0 ? s : "00";

        if (h < 10 && h > 0) {
            hDisplay = "0" + h + ":";
        }
        if (m < 10 && m > 0) {
            mDisplay = "0" + m + ":";
        }
        if (s < 10 && s > 0) {
            sDisplay = "0" + s;
        }

        return hDisplay + mDisplay + sDisplay;
    }
}
